import { TOAST_DURATION } from '@/constants'
import { mapGetters } from 'vuex'
import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'

export default {
  name: 'CustomRateList',
  components: {
    LayoutBasic
  },
  data () {
    return {
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 25
    }
  },
  computed: {
    ...mapGetters([
      'customRateItemsList'
    ])
  },
  methods: {
    deleteCustomRateItem (id) {
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/custom-rates'
      jsConn.formParams = {
        id: id
      }
      this.$store.dispatch('deleteCustomRateItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-warning',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
